// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__25hEO","inner":"Footer_inner__1TJui"};